var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBarBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60352 16.7557C9.03519 17.2365 9.58936 17.5007 10.1644 17.5007H10.1652C10.7427 17.5007 11.2994 17.2365 11.7319 16.7548C11.9635 16.499 12.3585 16.4782 12.6144 16.709C12.871 16.9398 12.8919 17.3356 12.661 17.5915C11.9877 18.339 11.1019 18.7507 10.1652 18.7507H10.1635C9.22935 18.7498 8.34519 18.3382 7.67436 17.5907C7.44352 17.3348 7.46435 16.939 7.72102 16.709C7.97769 16.4773 8.37269 16.4982 8.60352 16.7557ZM10.2059 0.833984C13.91 0.833984 16.3984 3.71898 16.3984 6.41315C16.3984 7.79898 16.7509 8.38648 17.125 9.00982C17.495 9.62482 17.9142 10.3232 17.9142 11.6432C17.6234 15.0157 14.1025 15.2907 10.2059 15.2907C6.30919 15.2907 2.78752 15.0157 2.50001 11.6965C2.49752 10.3232 2.91669 9.62482 3.28669 9.00982L3.41731 8.78995C3.73892 8.2372 4.01336 7.63595 4.01336 6.41315C4.01336 3.71898 6.50169 0.833984 10.2059 0.833984ZM10.2059 2.08398C7.29336 2.08398 5.26336 4.36565 5.26336 6.41315C5.26336 8.14565 4.78252 8.94648 4.35752 9.65315C4.01669 10.2207 3.74752 10.669 3.74752 11.6432C3.88669 13.2148 4.92419 14.0407 10.2059 14.0407C15.4584 14.0407 16.5284 13.1782 16.6667 11.589C16.6642 10.669 16.395 10.2207 16.0542 9.65315C15.6292 8.94648 15.1484 8.14565 15.1484 6.41315C15.1484 4.36565 13.1184 2.08398 10.2059 2.08398Z",
    fill: "#222222",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBarBellWhite);
export default __webpack_public_path__ + "static/media/bottom-bar-bell-white.aef867b07edbf84e2deda6d8cb3f06c7.svg";
export { ForwardRef as ReactComponent };